import React from 'react';
import LifecycleRules from '../../../sections/AdminDashboard/Configuration/LifecycleRules';

const Lifecycle = () => <LifecycleRules />;

export default Lifecycle;
